import { Flex, Grid, Input, Popover } from 'antd';
import SearchFilterIcon from 'icons/search-filter-blue.svg';
import SearchIcon from 'icons/search-icon.svg';
import React, { useState } from 'react';
import UserSearchForm from './user-search-form';

const UserSearchFilter = (props) => {
    const { Search } = Input;
    const [searchValue, setSearchValue] = useState<string>();
    const [isMoved, setIsMoved] = useState(false);
    const { md } = Grid.useBreakpoint();

    const extendedSearch = (value: any) => {
        props.onSearch(value);
    };

    const clear = () => {
        props.onClear();
    };

    const content = (
        <UserSearchForm
            extendedSearch={extendedSearch}
            search={searchValue}
            clear={clear}
        />
    );

    const onSearch = (value: string) => {
        extendedSearch({ fullName: value });
    };

    const onSearchChange = (value: any) => {
        setSearchValue(value.target.value);
    };

    const onPopoverOpenChange = (open: boolean) => {
        if (open && !isMoved) {
            setIsMoved(true);

            setTimeout(() => {
                const parent = document.querySelector('.ant-input-group-wrapper');
                const child = document.querySelector('div:has(.ant-popover)');

                parent.appendChild(child);
            }, 0);
        }
    };

    return (
        <div className="admin-user-list__filter">
            <Search
                placeholder="Поиск по ФИО"
                allowClear
                enterButton="Искать"
                size="large"
                prefix={<SearchIcon />}
                suffix={
                    md ? (
                        <Popover
                            content={content}
                            trigger="click"
                            placement={md ? 'bottomRight' : undefined}
                            arrow={false}
                            onOpenChange={onPopoverOpenChange}
                        >
                            <a className="d-flex align-items-center gap-2 suffix">
                                <SearchFilterIcon /> Расширенный поиск
                            </a>
                        </Popover>
                    ) : undefined
                }
                onSearch={onSearch}
                onChange={onSearchChange}
            />
            {!md && (
                <Flex
                    justify={'end'}
                    style={{
                        marginTop: 20,
                    }}
                >
                    <Popover
                        content={content}
                        trigger="click"
                        placement={md ? 'bottomRight' : undefined}
                        arrow={false}
                        onOpenChange={onPopoverOpenChange}
                    >
                        <a className="d-flex align-items-center gap-2 suffix">
                            <SearchFilterIcon /> Расширенный поиск
                        </a>
                    </Popover>
                </Flex>
            )}
        </div>
    );
};

export default UserSearchFilter;
